import { createI18n } from '@starling/core/i18n';

import ru from './locales/ru.json';
import kk from './locales/kk.json';

// i18n Vision: RU + KK с первого дня (starling-vision.md §2; EN из прототипа
// НЕ делаем — решение дизайн-дока, каркас расширяем при спросе).
// Словари: RU/KK-строки оболочки перенесены из STR прототипа (ветки `ru`/`kz`),
// строки состояний лент/деталей — наши.
// Механика init — общая обвязка `@starling/core/i18n`.

export const SUPPORTED_LANGUAGES = ['ru', 'kk'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'ru';

const STORAGE_KEY = 'sv.lang';

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** Сохранённый выбор языка; невалидное/отсутствующее значение → RU. */
export function readStoredLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isLanguage(stored) ? stored : DEFAULT_LANGUAGE;
  } catch {
    // Приватный режим / отключённое хранилище — не повод падать.
    return DEFAULT_LANGUAGE;
  }
}

export function storeLanguage(lang: Language): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* см. readStoredLanguage */
  }
}

const i18n = createI18n({
  resources: {
    ru: { translation: ru },
    kk: { translation: kk },
  },
  lng: readStoredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
});

/** Переключить язык интерфейса и запомнить выбор. */
export function changeLanguage(lang: Language): void {
  storeLanguage(lang);
  void i18n.changeLanguage(lang);
  document.documentElement.setAttribute('lang', lang);
}

export default i18n;
